import React, { PureComponent } from "react";
import axios from "axios";
import Billing from "../../components/Billing";
import { setThemeMode } from "../../tools/helper";
import { server, config, checkAccess } from "../../env";
import Alert from "../../components/Alert";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";

export default class PremiumResidential extends PureComponent {
  state = {
    mode: localStorage.getItem("themeMode"),
    plans: [],
    payment_methods: [],

    loader: "",
    message: "",
  };

  componentDidMount = () => {
    this.setMode(this.state.mode);
    document.title = "Purchase - Proxies.gg";

    this.checkBillingStatus();
    this.readPlans();
    this.readPaymentMethods();
  };

  checkBillingStatus = async () => {
    await axios
      .get(server + "/v1/billing/read", config)
      .then((rsp) => {
        this.setState({
          isBilling: true,
        });
      })
      .catch((err) => {
        // document.getElementById("billingModal").click();
      });
  };

  readPlans = async () => {
    await axios.get(server + "/v1/plan/read").then((rsp) => {
      this.setState({
        plans: rsp.data.payload.filter((plan) => plan.type === "PR_6"),
      });
    });
  };

  readPaymentMethods = async () => {
    await axios
      .get(server + "/v1/payment_method/read", config)
      .then((rsp) => {
        this.setState({
          payment_methods: rsp.data.payload,
        });
      })
      .catch((err) => {
        checkAccess(err);
      });
  };

  checkout = async (e) => {
    e.preventDefault();

    if (!this.state.isBilling) {
      document.getElementsByClassName("close")[0].click();
      document.getElementById("billingModal").click();
      return;
    }

    this.setState({
      loader: <Loader />,
    });

    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});
    params.plan = this.state.plan;
    params.proxyType = "PR_6";

    var payment_method = e.target.payment_method.value;

    payment_method = this.state.payment_methods.filter(
      (data) => data.id === parseInt(payment_method)
    )[0];

    await axios
      .post(server + "/v1/invoice/create", params, config)
      .then(async (rsp) => {
        if (
          payment_method.code === "crypto" ||
          payment_method.code === "coingate"
        )
          window.location.href = rsp.data.payload.hosted_url;
        else if (payment_method.code === "paddle") {
          // console.log(rsp.data.payload.hosted_url);
          window.Paddle.Setup({ vendor: 144858 });
          window.Paddle.Checkout.open({
            override: rsp.data.payload.hosted_url,
            disableLogout: true,
          });
        }
        this.setState({
          message: <Alert className="success" message={rsp.data.detail} />,
          loader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            message: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          loader: "",
        });
      });
  };

  setMode = (mode) => {
    setThemeMode(mode);
    this.setState({
      mode,
    });
  };

  setBilling = (isBilling) => {
    this.setState({
      isBilling,
    });
  };

  render() {
    const { plans, payment_methods } = this.state;
    const { message, loader } = this.state;

    return (
      <div className="main-content">
        <div className="pt-7 pb-8 bg-dark bg-ellipses">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-6">
                <h1 className="display-3 text-center text-white">
                  Premium Residential Proxies
                </h1>

                <p className="lead text-center text-muted">
                  We have plans and prices that fit your business perfectly.
                  Make your client site a success with our products.
                </p>
              </div>
            </div>
          </div>
          {/* <div className="container-fluid">
            <div className="row justify-content-between">
              <div className="col-auto"></div>
              <div className="col-auto">
                <div
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#buyAdditionalGb"
                >
                  Buy Additional GB
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="container-fluid">
          <div className="row mt-n7">
            {plans.map((plan, index) => (
              <div className="col-12 col-lg-4" key={index}>
                <div className="card">
                  <div className="card-body">
                    <h6 className="text-uppercase text-center text-muted my-4">
                      {plan.name}
                    </h6>

                    <div className="row g-0 align-items-center justify-content-center">
                      <div className="col-auto">
                        <div className="display-2 mb-0">
                          {(plan.price * plan.data).toFixed(2)}
                        </div>
                      </div>
                      <div className="col-auto">
                        <div className="h2 mb-0">€</div>
                      </div>
                    </div>

                    <div className="h6 text-uppercase text-center text-muted mb-5">
                      / month
                    </div>

                    <div className="mb-3">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                          <small>150+ Countries</small>{" "}
                          <i className="fe fe-check-circle text-success"></i>
                        </li>
                        <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                          <small>Unlimited Threads</small>{" "}
                          <i className="fe fe-check-circle text-success"></i>
                        </li>
                        <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                          <small>{plan.data} GB data included</small>
                          <i className="fe fe-check-circle text-success"></i>
                        </li>
                        <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                          <small>
                            {plan.add_gb_price.toFixed(2)}€ Per Additional GB
                          </small>
                          <i className="fe fe-check-circle text-success"></i>
                        </li>
                        <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                          <small> 24/7 Support</small>
                          <i className="fe fe-check-circle text-success"></i>
                        </li>
                      </ul>
                    </div>

                    <a
                      href="#!"
                      className="btn w-100 btn-primary"
                      onClick={() => this.setState({ plan: plan.id })}
                      data-bs-toggle="modal"
                      data-bs-target="#checkout"
                    >
                      Buy Now
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* checkout modal */}
        <Modal id="checkout" title="Purchase">
          <div className="modal-body">
            <form onSubmit={this.checkout}>
              {message}
              <div className="form-group">
                <label htmlFor="payment">Select Payment Method</label>
                <select
                  name="payment_method"
                  id="method"
                  className="form-control"
                  required
                >
                  {payment_methods.map((pm, index) => (
                    <option value={pm.id}>{pm.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="payment">Promo Code (optional)</label>
                <input
                  type="text"
                  name="coupon"
                  id="coupon"
                  className="form-control"
                  placeholder="Enter promo code here"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary w-100">
                  Checkout {loader}
                </button>
              </div>
            </form>
          </div>
        </Modal>

        <button
          className="hide d-none"
          data-bs-toggle="modal"
          data-bs-target="#billing"
          id="billingModal"
        ></button>
        <Billing setBilling={this.setBilling} />
      </div>
    );
  }
}
